import * as d3 from "d3";

export const tgc_color = (d) => {

  const color = d3
    .scaleOrdinal()
    .domain(["Good", "Moderate", "Bad"])
    .range(["#98BA78", "#F2D973", "#ED5D6B"]);

  if (d.name === '0 - 3 meter') {
    return color('Moderate');
  } else if (['Single pit lined', 'Double pit', 'Single pit unlined/ dug hole'].includes(d.name)) {
    return d.parent && d.parent.name === '0 - 3 meter' ? color('Bad') : color('Good');
  } else if (['Nearby water bodies', 'Open ground', 'Soak pit'].includes(d.name)) {
    return d.parent && d.parent.parent && d.parent.parent.name === '0 - 3 meter' ? color('Bad') : color('Moderate');
  } else {
    return color('Good');
  }
};

export const cas_color = (d) => {

  const color = d3
    .scaleOrdinal()
    .domain(["Good", "Moderate", "Bad"])
    .range(["#98BA78", "#F2D973", "#ED5D6B"]);

  if (d.name === '0 - 30 meters') {
    return color('Good');
  }

  const parentName = d.parent?.name;
  const grandparentName = d.parent?.parent?.name;

  if (d.name === 'Septic tank') {
    return parentName === '0 - 30 meters' ? color('Good') : color('Bad');
  }

  if (d.name === 'Single pit lined') {
    return parentName === '0 - 30 meters' ? color('Moderate') : color('Bad');
  }

  if (['Pick-up', 'Truck'].includes(d.name)) {
    if (grandparentName === '0 - 30 meters') {
      return parentName === 'Septic tank' ? color('Good') : color('Moderate');
    }
    return color('Bad');
  }

  if (['Van', 'Rickshaw'].includes(d.name)) {
    if (grandparentName === '0 - 30 meters') {
      return color('Moderate');
    }
    return color('Bad');
  }

  return color('Bad');
};



export const SWD_color = (d) => {
  const color = d3
    .scaleOrdinal()
    .domain(["Household dump", "Van collection", "Non-collectable", "Collectable", "Collected", "Open ground", "Dug hole", "Drain", "Nearby dustbin", "Roadside", "Municipality", "Local club", "Private agencies", "NGOs"])
    .range(["#F2D973", "#98BA78", "#ED5D6B", "#F6D057", "#769D55", "#E84951", "#E84951", "#E84951", "#5C7C3E", "#F7BF21", "#5C7C3E", "#5C7C3E", "#5C7C3E", "#5C7C3E"]);

  // Ensure d.name exists and is valid
  const key = d?.name || d?.data?.name;
  if (!key || !color.domain().includes(key)) {
    console.warn("SWD_color: Undefined or missing key", key);
    return "#ccc"; // Default fallback color
  }

  return color(key);
};
